import React from "react";
import { connect } from "react-redux";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import language from "../../language";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import bloodCenterSiteQuery from "../../utils/queries/bloodCenterSiteQuery";
import { getStorage } from "../../utils/storage";
import availableOptions from "../../constants/availableOptions";
import bloodCenterQuery from "../../utils/queries/bloodCenterQuery";
import { defineRoleCenterSite } from "../../utils/handleAccessRoles";

const statuses = [
  {
    label: "Available",
    value: "available",
  },

  {
    label: "In-use",
    value: "in-use",
  },

  {
    label: "Full",
    value: "full",
  },
  {
    label: "Damaged",
    value: "damaged",
  },
  {
    label: "Lost",
    value: "lost",
  },
];

const API_URL = process.env.REACT_APP_BBMS_BASE_API;
class NewEquipment extends React.Component {
  state = {
    name: "",
    error: {},
    isSubmitting: false,
    description: "",
    available: availableOptions[0],
    centers: [],
    centerSites: [],
    status: statuses[0],
  
    center: null,
    centerSite: null,
    department: null,
    maximumCapacity: "",
    type: null,
};

  componentDidMount = async () => {
    this.setState({ ...this.props });

    if (this.props._id && this.props._id !== "") {
      this.setState({
        code: this.props.code,
        name: this.props.name,
        description: this.props.description,
        available: this.props?.available
          ? {
              label: this.props?.available + "",
              value: this.props?.available + "",
            }
          : null,
        type: this.props?.type
          ? {
              label: this.props?.type + "",
              value: this.props?.type + "",
            }
          : null,
        department: this.props?.department
          ? {
              label: this.props?.department,
              value: this.props?.department,
            }
          : null,
        status: this.props?.status
          ? {
              label: this.props?.status,
              value: this.props?.status,
            }
          : null,
        center: this.props.center
          ? {
              ...this.props.center,
              label: this.props.center?.name,
              value: this.props.center?._id,
            }
          : null,
        centerSite:
          this.props.centerSite &&
          this.formatFormData(this.props.centerSite, "centerSite"),
      });

      // Load center site options without clearing the pre-filled value
      if (this.props.center?._id) {
        this.loadCenterSiteOptions(this.props.center._id);
      }
    }
  };

  formatFormData(data, field) {
    return Array.isArray(data)
      ? data.map((el) => {
          return {
            ...el,
            label: el?.name,
            value: el?._id,
          };
        })
      : [
          {
            ...data,
            label: data?.[field]?.name,
            value: data?.[field]?._id,
          },
        ];
  }

  onChangeText(field, e) {
    let { error } = this.state;
    delete error[field];

    const value = e && e?.target ? e?.target?.value : e;

    this.setState({
      [field]: value,
      error,
    });

    if (field === "center") {
      this.getCenterSites({ center: value?.value });
    }
  }

  getCenters = async (q) => {
    try {
      this.setState({
        isFetchingCenter: true,
      });

      const data = await bloodCenterQuery(this.props.defaultLanguage, {
        type: "dropdown",
        page: 1,
        limit: 50,
        q: q !== "" ? q : undefined,
      });

      let center = null;
      const { centerRole } = await defineRoleCenterSite();
      if (!this.props._id && centerRole) {
        data.forEach((el) => {
          if (centerRole.includes(el._id)) {
            center = el;
          }
        });

        this.setState({ center }, () => {
          this.getCenterSites({ center: center?.value });
        });
      }

      this.setState({
        centers: data,
        isFetchingCenter: false,
      });

      return data;
    } catch (error) {
      this.setState({ isFetchingCenter: false });

      return [];
    }
  };

  loadCenterSiteOptions = async (centerId) => {
    try {
      this.setState({ isFetchingCenterSite: true, centerSites: [] });
      const data = await bloodCenterSiteQuery(this.props.defaultLanguage, {
        type: "dropdown",
        page: 1,
        limit: 50,
        center: centerId,
      });
      this.setState({ centerSites: data, isFetchingCenterSite: false });
    } catch (error) {
      this.setState({ isFetchingCenterSite: false });
    }
  };

  getCenterSites = async (search = {}) => {
    try {
      this.setState({
        isFetchingCenterSite: true,
        centerSites: [],
        centerSite: null,
      });

      console.log(search);

      const data = await bloodCenterSiteQuery(this.props.defaultLanguage, {
        type: "dropdown",
        page: 1,
        limit: 50,
        ...search,
      });

      const { centerSiteRole } = await defineRoleCenterSite();
      let centerSite = null;

      if (!this.props._id && centerSiteRole) {
        data.forEach((el) => {
          if (centerSiteRole.includes(el._id)) {
            centerSite = el;
          }
        });

        this.setState({ centerSite });
      }

      this.setState({
        centerSites: data,
        isFetchingCenterSite: false,
      });

      return data;
    } catch (error) {
      console.log(error);
      this.setState({ isFetchingCenterSite: false });

      return [];
    }
  };

  validateForm() {
    let { name, error, code, department, maximumCapacity } = this.state;

    if (name === "") {
      error.name = language[this.props.defaultLanguage].name_required;
    }

    if (code === "") {
      error.code = language[this.props.defaultLanguage].code_required;
    }

    if (
      department &&
      department.value === "packaging" &&
      (!maximumCapacity || maximumCapacity === 0)
    ) {
      error.maximumCapacity =
        language[this.props.defaultLanguage].capacity_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      let {
          _id,
          name,
          description,
          available,
          code,
          center,
          department,
          centerSite,
          maximumCapacity,
          status,
          type,
        } = this.state,
        url = `${API_URL}/equipment`,
        method = "POST",
        user = await getStorage();

      let requestBody = {
        name,
        description,
        available: available.value,
        code,
        center: center?.value,
        centerSite: centerSite?.map((el) => el.value),
        department: department?.value,
        maximumCapacity,
        status: status?.value,
        type: type?.value,
      };

      if (_id && _id !== "") {
        method = "PUT";
        requestBody.id = _id;
      }

      const options = {
        method,
        url,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        data: requestBody,
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            method === "PUT"
              ? language[this.props.defaultLanguage].update_equipment_success
              : language[this.props.defaultLanguage].add_equipment_success
          );

          this.props.getData(true);
          this.props.handleCloseModal();
        })
        .catch((error) => {
          toastMessage("error", error);

          this.setState({
            isSubmitting: false,
          });
        });
    }
  };

  render() {
    return (
      <div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].code_placeholder
                }
                label={language[this.props.defaultLanguage].code}
                required
                value={this.state.code?.toUpperCase()}
                onChange={(e) => this.onChangeText("code", e)}
                error={this.state.error.code}
              />
            </div>
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].name_placeholder
                }
                label={language[this.props.defaultLanguage].name}
                required
                value={this.state.name}
                onChange={(e) => this.onChangeText("name", e)}
                error={this.state.error.name}
              />
            </div>
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].description_placeholder
                }
                label={language[this.props.defaultLanguage].description}
                value={this.state.description}
                onChange={(e) => this.onChangeText("description", e)}
                error={this.state.error.description}
              />
            </div>
            <div className="col-md-12">
              <Select
                loadOptions={(e) => this.getCenters(e)}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].center}
                value={this.state.center}
                onChange={(e) => this.onChangeText("center", e)}
                error={this.state.error.center}
                isLoading={this.state.isFetchingCenter}
              />
            </div>
            <div className="col-md-12">
              <Select
                options={this.state.centerSites}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].center_site}
                value={this.state.centerSite}
                onChange={(e) => this.onChangeText("centerSite", e)}
                error={this.state.error.centerSite}
                isLoading={this.state.isFetchingCenterSite}
                isMulti
              />
            </div>
            <div className="col-md-6">
              <Select
                options={[
                  {
                    label: "Vital sign",
                    value: "vital_sign",
                  },
                  {
                    label: "Donation",
                    value: "donation",
                  },
                  {
                    label: "Collection",
                    value: "collection",
                  },
                  {
                    label: "Production",
                    value: "production",
                  },
                  {
                    label: "Laboratory",
                    value: "laboratory",
                  },
                  {
                    label: "Separation",
                    value: "separation",
                  },
                  {
                    label: "Transformation",
                    value: "transformation",
                  },
                  {
                    label: "Archimede",
                    value: "archimede",
                  },
                  {
                    label: "Packaging",
                    value: "packaging",
                  },
                  {
                    label: "Transport",
                    value: "transport",
                  },
                  {
                    label: "Automation",
                    value: "automation",
                  },
                ]}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].department}
                value={this.state.department}
                onChange={(e) => this.onChangeText("department", e)}
                error={this.state.error.department}
                isCreatable
              />
            </div>
            <div className="col-md-6">
              <Select
                options={[
                  {
                    label: "BIG",
                    value: "BIG",
                  },
                  {
                    label: "MEDIUM",
                    value: "MEDIUM",
                  },
                  {
                    label: "SAMPLE",
                    value: "SAMPLE",
                  },
                ]}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].type}
                value={this.state.type}
                onChange={(e) => this.onChangeText("type", e)}
                error={this.state.error.type}
              />
            </div>

            {this.state?.department?.value === "packaging" && (
              <div className="col-md-12">
                <Input
                  placeholder={
                    language[this.props.defaultLanguage].enter_number
                  }
                  label={language[this.props.defaultLanguage].maximum_capacity}
                  required
                  value={this.state.maximumCapacity}
                  onChange={(e) => this.onChangeText("maximumCapacity", e)}
                  error={this.state.error.maximumCapacity}
                />
              </div>
            )}
            <div className="col-md-12">
              <Select
                options={statuses}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].status}
                value={this.state.status}
                onChange={(e) => this.onChangeText("status", e)}
                error={this.state.error.status}
              />
            </div>
            <div className="col-md-12">
              <Select
                options={availableOptions}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].available}
                required
                value={this.state.available}
                onChange={(e) => this.onChangeText("available", e)}
                error={this.state.error.available}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
            className="btn-default"
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            onPress={this.onSubmit.bind(this)}
            isSubmitting={this.state.isSubmitting}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewEquipment);
